var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Shape",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "E-commerce",
    transform: "translate(-192.000000, -64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconspace_Credit-Cards",
    transform: "translate(192.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#E6F0FC",
    id: "Shape",
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,17 L50,17 C51.6568542,17 53,18.3431458 53,20 L53,44 C53,45.6568542 51.6568542,47 50,47 L14,47 C12.3431458,47 11,45.6568542 11,44 L11,20 C11,18.3431458 12.3431458,17 14,17 Z",
    fill: "#154E84",
    fillRule: "nonzero",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,19 C13.4477153,19 13,19.4477153 13,20 L13,44 C13,44.5522847 13.4477153,45 14,45 L50,45 C50.5522847,45 51,44.5522847 51,44 L51,20 C51,19.4477153 50.5522847,19 50,19 L14,19 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFC200",
    height: 8,
    id: "Shape",
    rx: 1,
    width: 10,
    x: 16,
    y: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,38 L29,38 C29.5522847,38 30,38.4477153 30,39 L30,39 C30,39.5522847 29.5522847,40 29,40 L17,40 C16.4477153,40 16,39.5522847 16,39 L16,39 C16,38.4477153 16.4477153,38 17,38 Z",
    fill: "#52ABE2",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,34 L23,34 C23.5522847,34 24,34.4477153 24,35 L24,35 C24,35.5522847 23.5522847,36 23,36 L17,36 C16.4477153,36 16,35.5522847 16,35 L16,35 C16,34.4477153 16.4477153,34 17,34 Z",
    fill: "#52ABE2",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 37,
    fill: "#FFC200",
    id: "Shape",
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 37,
    fill: "#52ABE2",
    id: "Shape",
    r: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit_card_icon.4e0beccbadf3f4eb780a58f2d73dd9bb.svg";
export { ForwardRef as ReactComponent };